﻿import { rootElement } from '@shared/setup';
import AccountSettings from '@views/Account/AccountSettings/AccountSettings.vue';

const init = async () => {
    rootElement({
        name: 'account-settings', // pascal, camel & kebab-case are valid
        component: AccountSettings,
        vm: {},
        contextComponents: ['<div>waiting</div>'],
    });
};
init();
